(function() {
    'use strict';

    angular.module('settings.constants', [])
        .constant('variableMessagesConst', {
            add: 'Dodano nową zmienną!',
            update: 'Dane zmiennej zostały zaktualizowane!',
            delete: 'Zmienna została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('variablePermissionsConst', {
            view: {
                value: 'view_variable',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu zmiennych!'
            },
            add: {
                value: 'add_variable',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania zmiennych!'
            },
            update: {
                value: 'change_variable',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji zmiennych!'
            },
            delete: {
                value: 'delete_variable',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania zmiennych!'
            }
        })
        .constant('settingMessagesConst', {
            add: 'Dodano nową zmienną!',
            update: 'Dane zmiennej zostały zaktualizowane!',
            delete: 'Zmienna została usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('settingPermissionsConst', {
            view: {
                value: 'view_setting',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu zmiennych!'
            },
            add: {
                value: 'add_setting',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania zmiennych!'
            },
            update: {
                value: 'change_setting',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji zmiennych!'
            },
            delete: {
                value: 'delete_setting',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania zmiennych!'
            }
        })
        .constant('systemLogPermissionsConst', {
            view: {
                value: 'view_systemlog',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu logów systemowych!'
            },
            add: {
                value: 'add_systemlog',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania logów systemowych!'
            },
            update: {
                value: 'change_systemlog',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji logów systemowych!'
            },
            delete: {
                value: 'delete_systemlog',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania logów systemowych!'
            }
        })
        .constant('messagesMessagesConst', {
            add: 'Dodano nową sprawę!',
            update: 'Dane sprawy zostały zaktualizowane!',
            delete: 'Sprawa została usunięta!',
            send: 'Wiadomość została wysłana!',
            error: 'Wystąpił bład!'
        })
        .constant('clientcontactPermissionsConst', {
            view: {
                value: 'view_clientcontact',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu spraw!'
            },
            add: {
                value: 'add_clientcontact',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania spraw!'
            },
            update: {
                value: 'change_clientcontact',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji spraw!'
            },
            delete: {
                value: 'delete_clientcontact',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania spraw!'
            }
        })
        .constant('clientContactStatusConst', {
            new: 'new',
            open: 'open',
            close: 'close'
        })
        .constant('crmCaseStatusConst', {
            new: {
                value: 'new',
                title: 'Nowa'
            },
            open: {
                value: 'open',
                title: 'Otwarta'
            },
            close: {
                value: 'close',
                title: 'Zamknięta'
            }
        })
        .constant('messagesPermissionsConst', {
            view: {
                value: 'view_clientcontactmessage',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu spraw!'
            },
            add: {
                value: 'add_clientcontactmessage',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania spraw!'
            },
            update: {
                value: 'change_clientcontactmessage',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji spraw!'
            },
            delete: {
                value: 'delete_clientcontactmessage',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania spraw!'
            }
        })
        .constant('faqSectionsConst', [{
            title: '1',
            code: 'SECTION_ORDER'
        }, {
            title: '2',
            code: 'SECTION_PAYMENT'
        }, {
            title: '3',
            code: 'SECTION_DELIVERY'
        }])
        .constant('faqMessagesConst', {
            add: 'Dodano nowe faq!',
            update: 'Dane faq zostały zaktualizowane!',
            delete: 'Faq zostało usunięta!',
            error: 'Wystąpił bład!'
        })
        .constant('faqPermissionsConst', {
            view: {
                value: 'view_faq',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu faq!'
            },
            add: {
                value: 'add_faq',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania faq!'
            },
            update: {
                value: 'change_faq',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji faq!'
            },
            delete: {
                value: 'delete_faq',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania faq!'
            }
        })
        .constant('bannerMessagesConst', {
            add: 'Dodano nowy baner!',
            update: 'Dane banera zostały zaktualizowane!',
            delete: 'Baner został usunięty!',
            error: 'Wystąpił bład!'
        })
        .constant('bannerPermissionsConst', {
            view: {
                value: 'view_banner',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu banerów!'
            },
            add: {
                value: 'add_banner',
                errorMsg: 'Użytkownik nie ma uprawnień do dodania banerów!'
            },
            update: {
                value: 'change_banner',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji banerów!'
            },
            delete: {
                value: 'delete_banner',
                errorMsg: 'Użytkownik nie ma uprawnień do usuwania banerów!'
            }
        })
        .constant('translationPermissionsConst', {
            view: {
                value: 'view_localization',
                errorMsg: 'Użytkownik nie ma uprawnień do odczytu tłumaczeń!'
            },
            update: {
                value: 'change_localization',
                errorMsg: 'Użytkownik nie ma uprawnień do edycji tłumaczeń!'
            }
        })
        .constant('translationMessagesConst', {
            exportError: 'Nie udało się wyeksportować tłumaczeń.'
        })
        .constant('dataImportConst', {
            finished: 'Zakończony',
            notFinished: 'W trakcie'
        });
})();
